import script from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLogin.vue?vue&type=script&setup=true&lang=js"

import "./AuthLogin.vue?vue&type=style&index=0&id=2d7002ae&lang=scss"

const __exports__ = script;

export default __exports__